import { useMutation } from '@tanstack/react-query';
import * as z from 'zod';

import { REQUIRED_IDENTIFIER_TYPES } from 'src/features/gateway/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { SimulateGatewayPass } from 'src/features/actions/utils/types';
import { validationMessagesMap } from 'src/utils/messages';

type SimulateGatewayPassFormSchemaValues = z.infer<typeof simulateGatewayPassFormSchema>;
export type SimulateGatewayPassFnType = typeof simulateGatewayPass;

const simulateGatewayPassFormSchema = z
    .object({
        gateway: z.string().nonempty(),
        identifier_type: z.enum(REQUIRED_IDENTIFIER_TYPES),
        identifier_value: z.string().optional(),
        files: z.array(z.instanceof(File)).optional(),
    })
    .superRefine((data, ctx) => {
        if (data.identifier_type && !data.identifier_value) {
            ctx.addIssue({
                path: ['identifier_value'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });

const RESOURCE = `sp-core/:parkingId/visitors/visitor/simulate-pass/`;

type UseSimulateGatewayPass = MutationConfig<SimulateGatewayPassFnType, GeneralSmartParkError>;

interface DTO {
    formData: FormData;
    parkingId: string;
}
const simulateGatewayPass = ({ parkingId, formData }: DTO): Promise<SimulateGatewayPass> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

export const useSimulateGatewayPass = (options: UseSimulateGatewayPass = {}) =>
    useMutation({
        mutationFn: simulateGatewayPass,
        ...options,
    });
export { simulateGatewayPassFormSchema, RESOURCE as SIMULATE_GATEWAY_PASS_RESOURCE };
export type { SimulateGatewayPassFormSchemaValues };
